/* eslint-disable no-unused-vars */
import React from "react";
import { useSelector } from "react-redux";
import { duplicateData, taxPayerData } from "../../../../../../../../../store/Users/selectors";
import { InputTextContainer, Text } from "../../../../styled";
import GenericInput from "../../../GenericInput";
import { getPayerData } from "./constants";

const PayerInputs = () => {
  const payers = useSelector(taxPayerData);
  const dupData = useSelector(duplicateData);
  const elements = getPayerData(payers, dupData);

  const getInputs = (element) => {
    return (
      <InputTextContainer>
        <Text>{element.text}</Text>
        <GenericInput
          name={element.name}
          value={element.value}
          onChange={element.onChange}
          onBlur={element.onBlur}
          checked={element.checked}
          disabled={element.disabled}
          errorMessage={element.errorMessage}
        />
      </InputTextContainer>
    );
  };
  return <div>{elements.map(getInputs)}</div>;
};

export default PayerInputs;
